import type { Module } from "vuex/types/index.d.ts";
import type { DocumentResponseViewModel, Dictionary, GenerationDocument } from "@/models/viewModels";
import { $api } from "@/services/api";

const documentsModule: Module<any, any> = {
  namespaced: true,
  state: {
    ASDDocuments: [] as DocumentResponseViewModel[],
    ASDDictionary: {} as Dictionary<number>,
    IsGenerating: false,
  },
  mutations: {
    SET_ASD_DOCUMENTS(state: any, documents: DocumentResponseViewModel[]) {
      state.ASDDocuments = documents;
    },
    SET_ASD_DICTIONARY(state: any, payload: GenerationDocument) {
      state.ASDDictionary[payload.applicantId] = payload.documentId;
    },
    SET_GENERATING(state: any, generating: boolean) {
      state.IsGenerating = generating;
    },
  },
  actions: {
    getASDDocumentAsync({ dispatch, commit, state }, payload: GenerationDocument) {
      if (payload.applicantId in state.ASDDictionary) {
        payload.documentId = state.ASDDictionary[payload.applicantId].documentId;

        dispatch("getASDDocumentLinkAsync", payload);

        return;
      }

      if (state.IsGenerating) return;

      commit("SET_GENERATING", true);

      $api.refi
        .generateASDDocument(payload.applicantId)
        .then((documentId: number) => {
          payload.documentId = documentId;
          commit("SET_ASD_DICTIONARY", payload);
          dispatch("getASDDocumentLinkAsync", payload);
        })
        .finally(() => commit("SET_GENERATING", false));
    },
    getASDDocumentLinkAsync({ commit }, payload: GenerationDocument) {
      $api.documents
        .getApplicationDocumentViewLinks(payload.applicationId)
        .then((documents: DocumentResponseViewModel[]) => commit("SET_ASD_DOCUMENTS", documents));
    },
  },
  getters: {},
};

export default documentsModule;
